import { render, staticRenderFns } from "./PrintPosFaMed.vue?vue&type=template&id=ff0040c2&scoped=true"
import script from "./PrintPosFaMed.vue?vue&type=script&lang=js"
export * from "./PrintPosFaMed.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaMed.vue?vue&type=style&index=0&id=ff0040c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0040c2",
  null
  
)

export default component.exports